<template>
  <p>Websocket status</p>
</template>

<script>
import webSocketMixin from '@/mixins/webSocketMixin';
import { mapActions, mapState } from 'vuex';
import eventBus from '@/eventBus';

export default {
  name: 'CourseConnectionWebsocket',

  mixins: [webSocketMixin],
  socket: {
    skip() {
      return !(
        this.courseConnectionActivated &&
        this.user.can_manage_course_connections
      );
    },
    namespace: '/api/course-connection/',
    events: {
      message(event) {
        const data = JSON.parse(event.data);
        if (data.model === 'ConnectionLocation') {
          switch (data.type) {
            case 'model.list':
              if (data.instance.length > 0)
                eventBus.$emit(
                  'toggleStationPopover',
                  data.instance.map(station => station.name),
                  null
                );
              this.setCourseConnectionLocationActivated(
                data.instance.length > 0
              );
              break;
            case 'model.change':
              this.getCourseConnectionsLocations();
              eventBus.$emit('fetchNextCoursesAndAutoRefreshTime');
              eventBus.$emit(
                'toggleStationPopover',
                data.instance.name,
                data.action
              );
              if (data.action === 'delete') {
                this.getCourseConnectionsLocations().then(() => {
                  this.setCourseConnectionLocationActivated(
                    Object.keys(this.courseConnectionsLocations).length > 0
                  );
                });
              } else if (data.action === 'create') {
                this.setCourseConnectionLocationActivated(true);
              }
              break;
            case 'model.notification':
              this.getCourseConnectionsLocations();
              eventBus.$emit('fetchNextCoursesAndAutoRefreshTime');
              break;
          }
        } else if (data.model === 'Course') {
          switch (data.type) {
            case 'model.change':
              eventBus.$emit('fetchNextCoursesAndAutoRefreshTime');
              break;
          }
        }
      },
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['courseConnectionActivated']),
    ...mapState('courses', [
      'courseConnectionLocationActivated',
      'courseConnectionsLocations',
    ]),
  },
  methods: {
    ...mapActions('courses', [
      'setCourseConnectionLocationActivated',
      'getCourseConnectionsLocations',
    ]),
  },
};
</script>

<style lang="scss" scoped>
p {
  display: none;
  font-size: 2px;
}
</style>
